import { ACTIONS } from '../actions';

export const newEmergenciesReducer = (state = [], action) => {
    switch (action.type) {
        case ACTIONS.ADD_TO_NEW_EMERGENCIES:
            return [...state, action.payload];
        case ACTIONS.REMOVE_FROM_NEW_EMERGENCIES:
            return state.filter(e => e.id !== action.payload.id);
        default:
            return state
    }
}
